import {
  IPoint,
  instanceOfILocationSpecifiable,
  Vector,
  instanceOfIVectorCoordinatable,
  Rectangle,
  Point,
} from "../../../base/domain/drawing";

export class ComparisonUtility {
  static compareUpperLeftToRightBottom(a: unknown, b: unknown): number {
    const ya = this.getYLocation(a);
    const yb = this.getYLocation(b);
    return typeof ya !== "number" || typeof yb !== "number"
      ? 0
      : ya === yb
        ? this.compareXLocation(a, b)
        : ya - yb;
  }

  private static compareXLocation(a: unknown, b: unknown): number {
    const xa = this.getXLocation(a);
    const xb = this.getXLocation(b);
    return typeof xa !== "number" || typeof xb !== "number"
      ? 0
      : xa - xb;
  }

  private static getXLocation(object: unknown): number {
    const p = this.getLocation(object);
    return p && typeof p.x === "number"
      ? p.x
      : null;
  }

  private static getYLocation(object: unknown): number {
    const p = this.getLocation(object);
    return p && typeof p.y === "number"
      ? p.y
      : null;
  }

  private static getLocation(object: unknown): IPoint {
    if (instanceOfILocationSpecifiable(object)) {
      return object.location;
    } else if (instanceOfIVectorCoordinatable(object)) {
      return Point.to(Rectangle.from(Vector.from(object.vector)).topLeft);
    }
    return { x: null , y: null };
  }
}
